import { render, staticRenderFns } from "./DetailedQueries.vue?vue&type=template&id=638c995d&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./DetailedQueries.vue?vue&type=script&lang=js&"
export * from "./DetailedQueries.vue?vue&type=script&lang=js&"
import style0 from "./DetailedQueries.vue?vue&type=style&index=0&id=638c995d&scoped=true&lang=scss&"
import style1 from "./DetailedQueries.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638c995d",
  null
  
)

export default component.exports